import React, { useState, useEffect } from 'react';
// components
import Header from '../../components/header';
import BuyNow from '../../components/buyNowSection';
import Carousel from '../../components/carousel';
import Footer from '../../components/footer';
// toast
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// style
import './styles.css';
import { useHistory } from 'react-router';

const Dashboard = () => {
  const [dopplers, setDopplers] = useState([]);
  const [selected, setSelected] = useState('#fc1000');
  toast.configure();
  // Check if user logged out already or not!
  useEffect(() => {
    const alreadyLoggedIn = localStorage.getItem('token');
    if (alreadyLoggedIn) {
      history.push('/dashboard');
    } else {
      history.push('/');
      toast.error('Session expired login again to continue', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        // theme: 'colored',
      });
    }
  }, []);

  // get things api call
  useEffect(() => {
    fetch('v4/things', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((response) => response.json())
      .then((result) => {
        setDopplers(result['things']);
        localStorage.setItem('physicalId', result.things[0].info.physicalId);
      })
      .catch((error) => console.log(error));
  }, []);

  // useEffect(() => {
  //   fetch("http://sandman.test/api/getDeviceInfo", {
  //     method: "POST",
  //     headers: {
  //       Accept: "*/*",
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       token: localStorage.getItem("token"),
  //       physicalId: localStorage.getItem("physicalId"),
  //     }),
  //   })
  //     .then((response) => response.json())
  //     .then((response) => console.log(response))
  //     .catch((error) => console.log(error));
  // }, []);

  // Logout functionality implementation
  const history = useHistory();
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  return (
    <div className=''>
      <Header />
      <BuyNow />
      <Carousel />
      <section
        class='login-bg dashboard p-1'
        style={{ backgroundImage: 'url(./images/login-bg.jpg)' }}
      >
        <div
          class='container'
          style={{ flexDirection: 'row', display: 'flex' }}
        >
          <ul class='dashboard-menu'>
            <li>
              <a href='#'>HS Experts</a>
              <p>dev@hsexperts.com</p>
            </li>
            <li>
              <a href='#'>SUPPORT & FEEDBACK</a>
            </li>
            <li>
              <a href='/addDoppler'>ADD NEW DOPPLER</a>
            </li>
            <li>
              <a href='#'>ABOUT</a>
            </li>
            <li>
              <a href='#'>TERMS AND CONDISTIONS</a>
            </li>
            <li>
              <a href='#'>MANUAL</a>
            </li>
            <li>
              <a href='/amazonLogin'>AMAZON ALEXA APP</a>
            </li>
            <li>
              <a href='/settings'>SETTINGS</a>
            </li>
            <li>
              <button className='custom_btn_logout' onClick={handleLogout}>
                LOG OUT
              </button>
            </li>
          </ul>
          <div style={{ width: '50%', padding: 20 }}>
            <label
              style={{
                color: '#FFFFFF',
                fontSize: 22,
              }}
            >
              Choose a doppler:
            </label>
            <br />
            <br />
            <select
              style={{
                color: '#ffffff',
                backgroundColor: 'transparent',
                borderWidth: 2,
                borderColor: 'transparent',
                fontSize: 20,
              }}
            >
              {dopplers?.map((item, index) => {
                return (
                  <option
                    style={{ color: item['0'] ? '#ffffff' : '#868686' }}
                    key={index}
                    value={item.info.physicalId}
                  >
                    {item.info.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Dashboard;
